// 后台配置信息
export const BASE_CONFIG = 'BASE_CONFIG' // 添加用户信息

export const DEVICE_TYPE = 'DEVICE_TYPE'

export const FIXNAV_DH = 'FIXNAV_DH'

export const USER_INFO = 'USER_INFO'
